import {
  Component, Prop, Vue,
} from 'vue-property-decorator';
import router from '@/router';

import { VNode } from 'vue';
import { DialogView } from '@hb/coffee';
import { changeTabbarMaskStatus } from '@/api/native/container';
import isShowContainerPath from '@/shared/utils/isShowContainerPath';
import { dialogHelper } from '@/shared/utils/dialogHelper';
import { getTabIdByPath } from '@/shared/utils/getTabIdByPath/getTabIdByPath';
import style from './index.module.scss';

@Component({ name: 'ConfirmDialog' })
export default class ConfirmDialog extends Vue {
    @Prop({ default: '提交' })
    private confirmText!: string;

    @Prop({ default: '' })
    private cancelText!: string;

    @Prop()
    private title!: string;

    @Prop({ default: '' })
    private content?: string | VNode;

    // 埋点名称
    @Prop({ default: '' })
    private ubtName?: string;

    // 埋点业务参数
    @Prop({ default: {} })
    private businessInfo?: Dictionary<unknown>;

    private show = false;

    private showCloseIcon = true;

    private confirmBtnStyle = '';

    private cancelBtnStyle = '';

    private contentStyle = '';

    // 同意协议之后的回调
    private resolve: PromiseResolve<void> | null = null;

    private reject: PromiseReject | null = null;

    public open(params:{
      title: string,
      content?: string | VNode,
      confirmText?: string,
      cancelText?: string,
      confirmBtnStyle?: string,
      cancelBtnStyle?: string,
      ubtName?: string,
      businessInfo?: Dictionary<unknown>,
      contentStyle?: string,
      showCloseIcon?: boolean,
    }): Promise<void> {
      const {
        title, content, confirmText, ubtName, businessInfo, cancelText,
        confirmBtnStyle, cancelBtnStyle, contentStyle, showCloseIcon = true,
      } = params;
      // 埋点赋值
      this.ubtName = ubtName;
      this.businessInfo = businessInfo;
      if (this.ubtName) {
        this.$ubtModuleExposeNew(this.ubtName, this.businessInfo);
      }

      this.title = title;
      this.content = content;
      this.confirmText = confirmText || '';
      this.cancelText = cancelText || '';
      this.confirmBtnStyle = confirmBtnStyle || '';
      this.cancelBtnStyle = cancelBtnStyle || '';
      this.contentStyle = contentStyle || '';
      // 展示弹窗
      this.show = true;
      /** 页面已展示弹窗，同步状态到弹窗管理  */
      dialogHelper.applyOpenDialog(true);

      /** 在首页 我的页面 才显示tabbar遮罩 */
      if (isShowContainerPath(this.$route.path)) {
        changeTabbarMaskStatus({
          show: true,
          duration: 100,
          tabId: getTabIdByPath(),
        });
      }
      /** 是否展示关闭按钮 */
      this.showCloseIcon = showCloseIcon;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    }

    public close(): void {
      this.show = false;
      /** 关闭弹窗，同步到弹窗管理 */
      dialogHelper.closeDialogNotify();
      /** 隐藏tabbar遮罩 */
      changeTabbarMaskStatus({
        show: false,
        duration: 100,
        tabId: getTabIdByPath(),
      });
    }

    /** 关闭完，执行回调，由调用方决定 */
    private onConfirm() {
      this.close();
      if (this.ubtName) {
        this.$ubtPageButtonNew(this.ubtName, this.businessInfo);
      }

      if (this.resolve) {
        this.resolve();
      }
    }

    private onCancel() {
      this.close();

      if (this.reject) {
        this.reject();
      }
    }

    private render() {
      return (
            <div class={style.commonDialog}>
                <DialogView
                  show={this.show}
                  title={this.title}
                  closeable={this.showCloseIcon}
                  showCancelButton={!!this.cancelText}
                  confirmButtonText={this.confirmText}
                  cancelButtonText={this.cancelText}
                  onConfirm={this.onConfirm.bind(this)}
                  onCancel={this.onCancel.bind(this)}
                  onCloseIconClick={this.onCancel.bind(this)}
                >
                    {this.content && (
                        <div style={this.contentStyle}>
                            {this.content}
                        </div>
                    )}
                </DialogView>
            </div>
      );
    }
}

let instance: ConfirmDialog | undefined;

export const confirmDialog = {
  open(
    params:{
        title: string,
        content: string | VNode,
        confirmText: string,
        cancelText?: string,
        confirmBtnStyle?: string,
        cancelBtnStyle?: string,
        showCloseIcon?: boolean,
        ubtName?: string,
        businessInfo?: Dictionary<unknown>,
        contentStyle?: string,
    },
  ): Promise<void> {
    if (!instance) {
      instance = new ConfirmDialog({
        router,
      }).$mount();
      document.body.appendChild(instance.$el);
    }
    return instance.open(params);
  },
  close(): void {
    if (instance) {
      instance.close();

      if (instance.$el && instance.$el.parentElement) {
        instance.$el.parentElement.removeChild(instance.$el as Node);
      }

      instance = undefined;
    }
  },
};
